import { Controller } from "@hotwired/stimulus"
import { set } from "date-fns"

export default class extends Controller {

  static targets = [
    'form',
    'calculateButton',
    'image',
    'frame'
  ]

  static values = {
    calculateUrl: String,
    modalId: String,
  }

  // Configuration constants
  static ANIMATION_DURATION = 5500 // 5.5 seconds for loading animation

  connect() {
    // Hide modal on initial load and store original form action
    $(this.modalIdValue).modal('hide')
    this.formSubmissionUrl = this.formTarget.action
  }

  swapFormUrl(e) {
    e.preventDefault()

    // Validate required targets exist
    if (!this.hasFormTarget || !this.hasFrameTarget) {
      console.error('Required targets missing for commodity calculation')
      return
    }

    // Clear turbo frame content and show loading animation
    this.frameTarget.innerHTML = ''
    this.toggleImage(true)

    // Setup form for calculation submission
    this.formTarget.action = this.calculateUrlValue
    this.formTarget.dataset.turbo = 'true'

    if (this.formTarget.checkValidity()) {
      $(this.modalIdValue).modal('show')

      // Show loading animation for full duration
      setTimeout(() => {
        this.toggleImage(false)
        this.requestCalculation()
      }, this.constructor.ANIMATION_DURATION)
    } else {
      // Form validation failed, hide loading and submit normally
      this.toggleImage(false)
      this.requestCalculation()
    }
  }

  toggleImage(show) {
    // Safely toggle image visibility with error handling
    if (!this.hasImageTarget) {
      console.warn('Image target not found for commodity loading animation')
      return
    }

    if (show) {
      this.imageTarget.classList.remove('d-none')
    } else {
      this.imageTarget.classList.add('d-none')
    }
  }

  requestCalculation() {
    // Submit form for calculation and reset form state
    try {
      this.formTarget.requestSubmit()
      // Reset form action and turbo to false for saving of content
      this.formTarget.action = this.formSubmissionUrl
      this.formTarget.dataset.turbo = 'false'
    } catch (error) {
      console.error('Failed to submit commodity calculation form:', error)
      // Reset form state even if submission failed
      this.formTarget.action = this.formSubmissionUrl
      this.formTarget.dataset.turbo = 'false'
    }
  }

}
